import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId) {
  return apiFetch({ endPoint: 'AdditionalInfo/All?dossierSubTypeId=' + dossierSubTypeId, method: 'GET', body: null, token: token })
}
